export const START_ONBOARDING = '@ONBOARDINGNOW/START'

export const PREV_ONBOARDING = '@ONBOARDINGNOW/PREV'
export const NEXT_ONBOARDING = '@ONBOARDINGNOW/NEXT'

export const WEBSITE_WORDPRESS = '@ONBOARDING/WEBSITE_WORDPRESS'
export const WEBSITE_CUSTOM = '@ONBOARDING/WEBSITE_CUSTOM'

export const VALIDATE_SETUP_PROJECT = '@ONBOARDINGNOW/VALIDATE_SETUP_PROJECT'
export const VALIDATE_SETUP_CHANNELS = '@ONBOARDINGNOW/VALIDATE_SETUP_CHANNELS'
export const VALIDATE_CHOOSE_PLUGIN = '@ONBOARDINGNOW/VALIDATE_CHOOSE_PLUGIN'
export const VALIDATE_PLUGIN = '@ONBOARDINGNOW/VALIDATE_PLUGIN'
export const VALIDATE_PLUGIN_CUSTOM = '@ONBOARDINGNOW/VALIDATE_PLUGIN_CUSTOM'
export const VALIDATE_PLUGIN_WORDPRESS = '@ONBOARDINGNOW/VALIDATE_PLUGIN_WORDPRESS'

export const UPDATE_WEBSITE_URL = '@ONBOARDINGNOW/UPDATE_WEBSITE_URL'
export const UPDATE_PROJECT_NAME = '@ONBOARDINGNOW/UPDATE_PROJECT_NAME'

export const ADD_CHANNEL_ONBOARDING = '@ONBOARDINGNOW/ADD_CHANNEL_ONBOARDING'
export const REMOVE_CHANNEL_ONBOARDING = '@ONBOARDINGNOW/REMOVE_CHANNEL_ONBOARDING'
export const SET_CHANNEL_ONBOARDING = '@ONBOARDINGNOW/SET_CHANNEL_ONBOARDING'

export const SET_APPLICATION_CREATED = '@ONBOARDINGNOW/SET_APPLICATION_CREATED'

export const SET_WEBSITE_TYPE = '@ONBOARDINGNOW/SET_WEBSITE_TYPE'
